export const SCORE_RULES = {
  CORRECT_ANSWER: 1,
};

export function isTestAnswerCorrect(question, selectedOption) {
  if (!question || !selectedOption) return false;
  return selectedOption === question.correctAnswer;
}

export function isDropdownAnswerCorrect(question, dropdownValues) {
  const correctAnswers = question?.correctAnswers;
  if (!correctAnswers || typeof correctAnswers !== "object") return false;

  return Object.keys(correctAnswers).every(
    (key) => dropdownValues?.[key] === correctAnswers[key]
  );
}
